var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.798,
    height: 65.798,
    viewBox: "0 0 65.798 65.798",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_Navigation_icon_12_states_",
    "data-name": "Icons / Navigation icon (12 states)",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_users",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M0,0H65.8V65.8H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 10.966,
    cy: 10.966,
    rx: 10.966,
    ry: 10.966,
    transform: "translate(13.708 8.225)",
    fill: "none",
    stroke: "#f2f2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M3,31.449V25.966A10.966,10.966,0,0,1,13.966,15H24.933A10.966,10.966,0,0,1,35.9,25.966v5.483",
    transform: "translate(5.225 26.124)",
    fill: "none",
    stroke: "#f2f2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M16,3.13a10.966,10.966,0,0,1,0,21.247",
    transform: "translate(27.865 5.451)",
    fill: "none",
    stroke: "#f2f2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M26.225,31.188V25.705A10.966,10.966,0,0,0,18,15.15",
    transform: "translate(31.349 26.385)",
    fill: "none",
    stroke: "#f2f2f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMembers);
export default __webpack_public_path__ + "static/media/icon-members.0c743aa5b631aa03b14c454957c33c05.svg";
export { ForwardRef as ReactComponent };